import { MatPaginatorIntl } from '@angular/material/paginator';
const frRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) {
    return `0 sur ${length}`;
  }
  length = Math.max(length, 0);
  const startIndex = page * pageSize;
  const endIndex =
    startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} sur ${length}`;
};

export function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();
  //Items per page => Éléments par page
  customPaginatorIntl.itemsPerPageLabel = 'Éléments par page :';
  // 1 – 15 of 18008 =>  1 – 15 sur 18008
  customPaginatorIntl.getRangeLabel = frRangeLabel;
  return customPaginatorIntl;
}
